import { createRouter, createWebHistory } from "vue-router"
import { useUserStore } from '../pinia/userStore'
import { ElMessage } from "element-plus"
import { check_loginstatus } from "@/api/chat"
import { initMenu } from "@/utils/menus"
import { createStore } from 'vuex'
import { getMenu } from "@/api/request"
import service from "@/utils/request"
import { isToHome } from "@/api/user"

const store = createStore();

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "/login",
            name: "index",
            component: () => import('../views/login.vue')
        },
        {
            path: '/',
            name: 'home',
            component: () => import('../views/home.vue')
        },
        {
            path: '/mobile_home',
            name: 'mobile_home',
            component: () => import('../views/mobile_home.vue')
        },
        {
            path: '/chatV2',
            name: 'chatV2',
            component: () => import('../views/chat/chatV2.vue')
        },
        {
            path: '/mobile_chatV2',
            name: 'mobile_chatV2',
            component: () => import('../views/chat/mobile_chatV2.vue')
        }
    ]
})

export const generateRoutes = async () => {
    const userStore = useUserStore()
    let menus = await getMenu();
    userStore.menuList = menus;

    // 将菜单数据转换为路由格式
    userStore.dynamicRoutes = transformMenuToRoutes(menus)
}

export const transformMenuToRoutes = (menuList) => {
    const routes = []
    menuList.forEach(menu => {
        const route = {
            path: menu.path,
            name: menu.name,
            component: getComponent(menu),
            iconCls: menu.iconCls,
            meta: {
                title: menu.title,
                icon: menu.icon,
                keepAlive: menu.keepAlive === 1
            }
        }

        if (menu.children && menu.children.length > 0) {
            route.children = transformMenuToRoutes(menu.children)
        }
        routes.push(route)
    })
    return routes
}

export const getComponent = (menu) => {
    if (!menu) return null
    // 组件映射
    const componentMap = {
        //'Layout': () => import('@/views/layout.vue'),
        'Home': () => import('@/views/home.vue')
        // 可以添加更多组件映射
    }
    if (menu.path.startsWith("/home")) {
        return (() => import(`@/views/${menu.component}.vue`))
    } else if (menu.path.startsWith("/category")) {
        return (() => import(`@/views/category/${menu.component}.vue`))
    } else if (menu.path.startsWith("/index")) {
        return (() => import(`@/views/index/${menu.component}.vue`))
    } else if (menu.path.startsWith("/knowledge")) {
        return (() => import(`@/views/knowledge/${menu.component}.vue`))
    } else if (menu.path.startsWith("/app")) {
        return (() => import(`@/views/app/${menu.component}.vue`))
    } else if (menu.path.startsWith("/user")) {
        return (() => import(`@/views/user/${menu.component}.vue`))
    } else if (menu.path.startsWith("/role")) {
        return (() => import(`@/views/role/${menu.component}.vue`))
    } else if (menu.path.startsWith("/dept")) {
        return (() => import(`@/views/dept/${menu.component}.vue`))
    } else if (menu.path.startsWith("/chat")) {
        return (() => import(`@/views/chat/${menu.component}.vue`))
    } else if (menu.path.startsWith("/logs")) {
        return (() => import(`@/views/logs/${menu.component}.vue`))
    } else if (menu.path.startsWith("/logo")) {
        return (() => import(`@/views/logo/${menu.component}.vue`))
    } else if (menu.path.startsWith("/claw")) {
        return (() => import(`@/views/claw/${menu.component}.vue`))
    }
    /*if (component.component != 'home') {
        return componentMap[component] || (() => import(`@/views${component.path}.vue`))
    } else {
        return componentMap[component] || (() => import(`@/views${component.path}.vue`))
    }*/

}

router.beforeEach(async (to, from, next) => {
    // 已登录状态
    const userStore = useUserStore()
    if (userStore.token) {
        await check_loginstatus({token: window.localStorage.getItem("ai_employee_token")}).then(async (resp) => {
            if (resp == undefined) {
                userStore.token = "";
                userStore.userInfo = "";
                localStorage.removeItem("ai_employee_token");
                localStorage.removeItem("ai_employee_userInfo");
                next('/login')
            } else {
                let sta = resp.status;
                if(sta == 200) {
                    if (to.path === '/login') {
                        next('/')
                        //next('/login')
                    } else {
                        if (to.path == '/') {
                            //next('/home')
                            let is = await isToHome();
                            if (!is) {
                                window.location.href = '/chatV2';
                            } else {
                                window.location.href = '/home';
                            }
                        } else if (to.path == '/home') {
                            let is = await isToHome();
                            if (!is) {
                                window.location.href = '/chatV2';
                            }
                        } else if (to.path == '/mobile_home') {
                            let is = await isToHome();
                            if (!is) {
                                window.location.href = '/mobile_chatV2';
                            }
                        }
                        // 检查是否已加载动态路由
                        if (!userStore.menuList || userStore.menuList.length === 0) {
                            try {
                                await generateRoutes();
                                // 添加动态路由
                                userStore.dynamicRoutes.forEach(route => {
                                    router.addRoute(route)
                                })

                                // 重定向到目标路由
                                next({ ...to, replace: true })
                                //next('/home');
                                //window.location.href = '/home';
                            } catch (error) {
                                userStore.token = "";
                                userStore.userInfo = "";
                                localStorage.removeItem("ai_employee_token");
                                localStorage.removeItem("ai_employee_userInfo");
                                next('/login')
                            }
                        } else {
                            next()
                        }
                    }
                } else {
                    userStore.token = "";
                    userStore.userInfo = "";
                    localStorage.removeItem("ai_employee_token");
                    localStorage.removeItem("ai_employee_userInfo");
                    next('/login')
                }
            }
        })
    } else {
        // 未登录状态
        if (to.path === '/login') {
            next()
        } else {
            next('/login')
        }
    }
})

/*export const addDynamicRoutes = async () => {
    try {
        const res = await getMenu()
        const menuList = res;
        console.log(menuList);
        // 递归处理菜单，生成路由
        const generateRoutes = (menus) => {
            const routes = []
            menus.forEach(menu => {
                if (menu.component && menu.path) {
                    const route = {
                        path: menu.path,
                        name: menu.menuName,
                        component: () => import(`@/views/${menu.component}.vue`),
                        meta: { title: menu.menuName, icon: menu.icon }
                    }
                    routes.push(route)
                }
                if (menu.children && menu.children.length > 0) {
                    routes.push(...generateRoutes(menu.children))
                }
            })
            return routes
        }
        const dynamicRoutes = generateRoutes(menuList)
        // 添加到Layout的子路由
        dynamicRoutes.forEach(route => {
            router.addRoute('Layout', route)
        })
        return dynamicRoutes
    } catch (error) {
        ElMessage.error('获取菜单失败，请重新登录')
        localStorage.removeItem("ai_employee_token");
        localStorage.removeItem("ai_employee_userInfo");
        router.push('/login')
        return []
    }
}*/

/*router.beforeEach(async (to, from, next) => {
    const isLogin = document.cookie.includes('JSESSIONID') // 通过Session判断是否登录
    console.log(to.path);
    if (to.path === '/login') {
        if (isLogin) {
            next('/')
        } else {
            next()
        }
    } else {
        if (isLogin) {
            // 如果是首次进入，动态添加路由
            if (router.getRoutes().filter(r => r.path !== '/login' && r.path !== '/' && r.path !== '/home').length === 0) {
                await addDynamicRoutes()
                // 重新跳转（解决首次动态路由不生效）
                next({ ...to, replace: true })
            } else {
                next()
            }
        } else {
            next('/login')
        }
    }
})*/

/*router.beforeEach((to, from, next) => {
    //判断
    if (window.localStorage.getItem("ai_employee_token")) {
        check_loginstatus({token: window.localStorage.getItem("ai_employee_token")}).then(resp => {
            if (resp) {
                let status = resp.status
                if (status == 200) {
                    if (router.getRoutes().filter(r => r.path !== '/login' && r.path !== '/' && r.path !== '/home').length === 0) {
                        initMenu(router, store);
                        //addDynamicRoutes()
                        // 重新跳转（解决首次动态路由不生效）
                        next({ ...to, replace: true })
                    } else {
                        next()
                    }
                    /!*initMenu(router, store)
                    if (!window.localStorage.getItem("user")) {
                        return getRequest("/user/info").then(resp => {
                            if (resp) {
                                //存入用户信息
                                window.localStorage.setItem("user", JSON.stringify(resp))
                                store.commit("INIT_CURRENTAdmin", resp)
                                next()
                            }
                        })
                    }*!/
                    if (to.path == "/") {
                        next("/home")
                    } else {
                        next()
                    }
                } else if (status == 401) {
                    /!*ElMessage.error("登录失效，请重新登录", "重复登录", {
                        confirmButtonText: "确定",
                        callback: action => {
                            window.localStorage.removeItem("user")
                            window.localStorage.removeItem("cnbossTokenStr")
                            store.commit("initRoutes", [])
                            window.sessionStorage.removeItem("activePath")
                            router.replace("/")
                        }
                    })*!/
                    return
                } else if (status == 409) {
                    /!*MessageBox.alert("该账户已在其他位置登录", "重复登录", {
                        confirmButtonText: "确定",
                        callback: action => {
                            window.localStorage.removeItem("user")
                            window.localStorage.removeItem("cnbossTokenStr")
                            store.commit("initRoutes", [])
                            window.sessionStorage.removeItem("activePath")
                            router.replace("/")
                        }
                    })*!/
                    return
                }
            }
        })
    } else {
        if (to.path == "/") {
            next()
        } else {
            //next('/?redirect=' + to.path);
            next("/")
        }
    }
})*/

export default router